// @flow
import React, { type Node } from 'react';

import styles from './ControlsLayout.scss';


type Props = {
  leftContent?: Node,
  children: Node,
}

const ControlsLayout = ({ leftContent, children }: Props): Node => {
  return (
    <div className={styles.root}>
      <div>
        {leftContent}
      </div>
      {children}
    </div>
  );
};

export default ControlsLayout;
